import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";

import FontAwesomeIcon from "@/libs/FontAwesomeIcon.vue";

library.add(fas, far);

export { FontAwesomeIcon };
